import palomaBackend from "@astina/paloma-common-ui/src/services/PalomaBackend";
import { handleHttpError } from "@astina/paloma-common-ui/src/services/Alerts";
import env from '../services/AppEnv';
import { demand as config } from "@astina/paloma-shop-common-ui/src/services/RepositoryConfig";
import trans from '@astina/paloma-common-ui/src/services/Translator';
const http = palomaBackend.http;
class DemandRepository {
    getCalendarData(searchRequest) {
        return http
            .post(`${config.path}/calendar`, searchRequest, {
            params: {
                locale: env.locale,
            }
        })
            .then(response => response.data)
            .catch(handleHttpError);
    }
    downloadDemandData(searchRequest) {
        return http
            .post(`${config.path}/download`, searchRequest, {
            params: {
                locale: env.locale,
            },
            responseType: 'blob',
        })
            .then(response => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = env.customer.company + " " + trans("demand_document.heading") + '.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        })
            .catch(handleHttpError);
    }
}
export default new DemandRepository();
